import React, { Component } from "react";
import axios from "axios";
import { routes } from "../gen/General";
import { find_aseg } from "../api/CacheApi";
import { UncontrolledTooltip } from "reactstrap";

export const Activo = props => {
    return (
        <React.Fragment>{props.valor === true || props.valor === 1 ? <span>SI</span> : <span>NO</span>}</React.Fragment>
    );
};

export class NombreEmp extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            nm: null,
        };
    }

    fetchData = () => {
        if (this.props.cod) {
            this.loadEmpresa(this.props.cod).then(emp => this.setState({ nm: emp.nm }));
        }
    };

    loadEmpresa = idE => {
        return new Promise(function (resolve, reject) {
            axios
                .get(routes.api + "/empresa/" + idE)
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cod !== prevProps.cod) {
            this.fetchData();
        }
    }

    render() {
        return <span>{this.state.nm}</span>;
    }
}

export class NombreSucursal extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            nm: "",
        };
    }

    fetchData = () => {
        if (this.props.cod) {
            this.loadSucursal(this.props.cod);
        }
    };

    loadSucursal = cdCompania => {
        let list = this.props.list;
        let comp = list.find(a => a.cdCompania === cdCompania);
        this.setState({ nm: comp ? comp.aliasCompania : "" });
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cod !== prevProps.cod) {
            this.fetchData();
        }
    }

    render() {
        return <span>{this.state.nm}</span>;
    }
}

export class NombreAseguradora extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            nm: "",
        };
    }

    fetchData = () => {
        if (this.props.cod) {
            find_aseg(this.props.cod).then(aseg => this.setState({ nm: aseg ? aseg.nmAlias : "" }));
        }
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cod !== prevProps.cod) {
            this.fetchData();
        }
    }

    render() {
        return <span>{this.state.nm}</span>;
    }
}

export class NombreRamo extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            nm: "",
        };
    }

    fetchData = () => {
        if (this.props.cod) {
            this.loadRamo(this.props.cod);
        }
    };

    loadRamo = cdRamo => {
        let list = this.props.list;
        let ramo = list.find(r => r.cdRamo === cdRamo);
        this.setState({ nm: ramo ? ramo.nmRamo : "" });
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cod !== prevProps.cod) {
            this.fetchData();
        }
    }

    render() {
        return <span>{this.state.nm}</span>;
    }
}

export class NombreCliente extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            nm: "",
        };
    }

    fetchData = () => {
        if (this.props.cod) {
            this.loadCliente(this.props.cod).then(clt =>
                this.setState({ nm: clt ? clt.nmCliente + " " + (clt.apCliente ? clt.apCliente : "") : "" })
            );
        }
    };

    loadCliente = cdCliente => {
        return new Promise(function (resolve, reject) {
            axios
                .get(routes.api + "/usuario", { params: { cdCliente } })
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cod !== prevProps.cod) {
            this.fetchData();
        }
    }

    render() {
        return <span>{this.state.nm}</span>;
    }
}

export class DscPlan extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            nm: "",
        };
    }

    fetchData = () => {
        if (this.props.cod) {
            this.loadPlan(this.props.cod).then(plan => this.setState({ nm: plan ? plan.dscPlan : "" }));
        }
    };

    loadPlan = cdUbicacion => {
        return new Promise(function (resolve, reject) {
            axios
                .get(routes.api + "/plan/" + cdUbicacion)
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cod !== prevProps.cod) {
            this.fetchData();
        }
    }

    render() {
        return <span>{this.state.nm}</span>;
    }
}

export const ESTADOS_ROJO = ["C.H..NOTA.COB.CLI", "C.H.NOTA.COB.ASEG"];

export const siniestroIsLiquidado = siniestro => {
    return siniestro.estado === "X" || ESTADOS_ROJO.indexOf(siniestro.aliasEstado) >= 0;
};

export const NombreTitular = ({ row }) => {
    function estadoColor(estadoLiquidado) {
        if (ESTADOS_ROJO.indexOf(estadoLiquidado) >= 0) {
            return "red";
        } else if (row.estado && row.estado === "X") {
            return "#495057";
        } else {
            return "yellow";
        }
    }

    function estadoMensaje(estadoLiquidado) {
        if (ESTADOS_ROJO.indexOf(estadoLiquidado) >= 0) {
            return "Nota de cobranza Pendiente";
        } else if (row.estado && row.estado === "X") {
            return "Liquidado";
        } else {
            return "Pendiente";
        }
    }

    let estado = estadoColor(row.aliasEstado);
    let mensaje = estadoMensaje(row.aliasEstado);
    return (
        <div>
            <i id={"c-" + row.cdReclamo} className="fas fa-circle mr-2" style={{ color: estado }} />
            <UncontrolledTooltip placement="top" target={"c-" + row.cdReclamo} className={"mod-tooltip"}>
                {mensaje}
            </UncontrolledTooltip>
            <span>{row.titular}</span>
        </div>
    );
};
